import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { TrendingUpIcon } from 'lucide-react';
export function ProofSection() {
  return <AnimatedSection className="py-16 md:py-24 px-6 max-w-3xl mx-auto" data-id="element-286">
      <div className="bg-sage/10 rounded-3xl p-8 md:p-12 border border-sage/20 text-center" data-id="element-287">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-sage/20 rounded-full mb-6" data-id="element-288">
          <TrendingUpIcon className="w-8 h-8 text-sage" data-id="element-289" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-290">
          ¿Qué cambia en una semana?
        </h2>

        <div className="space-y-4 text-lg text-charcoal/80 leading-relaxed max-w-2xl mx-auto" data-id="element-291">
          <p data-id="element-292">
            Al entrenar tu nervio vago diariamente, tu{' '}
            <span className="text-sage font-semibold" data-id="element-293">
              "umbral de estrés" sube
            </span>
            .
          </p>
          <p data-id="element-294">
            Lo que antes te hacía estallar o entrar en pánico, ahora se siente{' '}
            <span className="font-semibold" data-id="element-295">manejable</span>.
          </p>
          <p className="text-charcoal font-semibold text-xl pt-4" data-id="element-296">
            No es magia, es técnica.
          </p>
        </div>
      </div>
    </AnimatedSection>;
}